import "../styles/SizeGuidePage.css";
import Footer from "../../../../../components/Footer/Footer";

import useSizeGuide from "../hooks/useSizeGuideData";
import SizeGuideSkeleton from "../components/SizeGuideSkeleton";
import HeroSection from "../components/HeroSection";
import CarpetGuide from "../components/CarpetGuide";
import RoomGuide from "../components/RoomGuide";

export default function SizeGuidePage() {
  const {
    data,
    loading,

    activeShape,
    shapeData,
    selectShape,
    tabLoading,

    activeRoom,
    roomData,
    selectRoom,
    roomTabLoading,
  } = useSizeGuide();

  if (loading || !data) {
    return <SizeGuideSkeleton />;
  }

  const carpetGuide = data?.content?.[0];
  const roomGuide = data?.content?.[1];

  return (
    <>
      <div className="styleguide-container">
        <HeroSection banner={data.size_guide_banners} />

        <CarpetGuide
          title={carpetGuide?.title}
          guides={carpetGuide?.size_guides}
          activeId={activeShape}
          activeData={shapeData}
          onChange={selectShape}
          loading={tabLoading}
        />

        <RoomGuide
          title={roomGuide?.title}
          rooms={roomGuide?.size_guides}
          activeId={activeRoom}
          activeRoom={roomData}
          onChange={selectRoom}
          loading={roomTabLoading}
        />
      </div>

      <Footer />
    </>
  );
}

